import { z } from 'zod';
import { zGoSlice } from '../helpers/fix-go-types';
import { reorderWeeks, thresholdWeeks } from './order-settings';
import { saleStatDays } from './product';

// form validation rules
//
// looseObject, not object, and the distinction is load-bearing — see
// qoh_threshold_percent below. Every other schema in this family is strict.
export const OrderOptionsSchema = z.looseObject({
  qoh_threshold_weeks: z.literal(thresholdWeeks),
  reorder_weeks: z.literal(reorderWeeks),

  // Go tags these `[]string` with no omitempty, so a nil slice reaches us as
  // null rather than an absent key.
  send_methods: zGoSlice(z.string()),
  emails: zGoSlice(z.email()),

  // qoh_threshold_percent is deliberately not declared. Nothing reads it, and
  // requiring it here is what would break the deploy window when the API stops
  // sending it (ORD-391): a browser on the old bundle would fail validation on
  // every order response. The schema is loose rather than strict so the value
  // still round-trips and the API's `required` stays satisfied until the field
  // is removed server-side — a plain z.object() would STRIP it, the client
  // would stop sending it back on PUT, and Go's validate:"required" would 400
  // every reorder-settings save. See the round-trip test.
  //
  // sales_period_days IS still read by getSuggestedQuantities, so it stays.
  sales_period_days: z.literal(saleStatDays),
});

export type OrderOptions = z.infer<typeof OrderOptionsSchema>;
